export enum Resources {
  PROJECTS = 'projects',
  EVENTS = 'events',
  TRAININGS = 'trainings',
  ORGANIZATION_RELATIONS = 'organization-relations',
  PERSONS = 'persons',
}
